import PropTypes from "prop-types";
import React from "react";
import CommonDialog from "@/Components/Common/CommonDialog";
import { CSVLink } from "react-csv";

const ExportCSVModal = ({ show, onCloseClick, data, tossData, onTossExport }) => {
  const csvLinkRef = React.useRef<any>(null);
  const hasTossRows = tossData?.length > 0;

  return (
    <CommonDialog
      isOpen={show}
      onClose={onCloseClick}
      title="CSV 내보내기"
      description={
        hasTossRows
          ? "토스 양식으로 다운로드 시, 토스 결제 건만 포함하며 부분취소 주문은 제외합니다. 토스 대량취소 이용 시, 부분취소가 되지 않으므로 부분취소 건은 토스상점관리자 에서 건별 취소 처리해 주세요."
          : "CSV 파일을 내보내시겠습니까? 토스 결제 건 중 부분취소가 아닌 주문이 없습니다."
      }
      tone="warning"
      actions={[
        {
          label: "닫기",
          color: "light",
          closeOnClick: false,
          onClick: onCloseClick,
        },
        {
          label: "다운로드",
          color: "success",
          closeOnClick: false,
          onClick: () => {
            csvLinkRef.current?.link?.click();
            onCloseClick?.();
          },
        },
        {
          label: "토스 양식으로 출력",
          color: "primary",
          disabled: !hasTossRows,
          closeOnClick: false,
          onClick: () => {
            onTossExport?.();
            onCloseClick?.();
          },
        },
      ]}
    >
      <CSVLink
        data={data}
        className="d-none"
        ref={csvLinkRef}
      >
        download
      </CSVLink>
    </CommonDialog>
  );
};

ExportCSVModal.propTypes = {
  onCloseClick: PropTypes.func,
  data: PropTypes.any,
  show: PropTypes.any,
  tossData: PropTypes.any,
  onTossExport: PropTypes.func,
};

export default ExportCSVModal;
